import PropTypes from 'prop-types';
import HighCharts from '../HighCharts';

import s from './ColumnChartBlock.module.css';

const ColumnChartBlock = ({
    title,
    displayLargeTitle,
    showTitleInToc,

    yAxisLabel,
    yAxisStackValues = false,
    yAxisMin,
    yAxisMax,
    yAxisTickInterval,

    decimalPlaces,

    xAxisLabel,
    xAxisLabelFormattting,
    xAxisCategorySortingType,
    xAxisCategoryOrdering,

    aggregateDataByCategory,

    propertySeriesQueries,
    aggregateSeriesQueries,

    dynamicProperty,
}) => {
    const plotOptions = {
        series: {
            stacking: yAxisStackValues,
            dataLabels: {
                // enabled: yAxisStackValues,
                enabled: false,
            },
        },
    };

    return (
        <div className={s.Root}>
            <HighCharts
                chartType="column"
                title={title}
                showTitleInToc={showTitleInToc}
                displayLargeTitle={displayLargeTitle}
                yAxisLabel={yAxisLabel}
                yAxisMin={yAxisMin}
                yAxisMax={yAxisMax}
                yAxisTickInterval={yAxisTickInterval}
                decimalPlaces={decimalPlaces}
                xAxisLabel={xAxisLabel}
                xAxisLabelFormattting={xAxisLabelFormattting}
                xAxisCategorySortingType={xAxisCategorySortingType}
                xAxisCategoryOrdering={xAxisCategoryOrdering}
                aggregateDataByCategory={aggregateDataByCategory}
                propertySeriesQueries={propertySeriesQueries}
                aggregateSeriesQueries={aggregateSeriesQueries}
                dynamicProperty={dynamicProperty}
                plotOptions={plotOptions}
            />
        </div>
    );
};

ColumnChartBlock.propTypes = {
    title: PropTypes.string,
    displayLargeTitle: PropTypes.bool,
    showTitleInToc: PropTypes.bool,

    xAxisLabel: PropTypes.string,
    yAxisStackValues: PropTypes.bool,
    xAxisLabelFormattting: PropTypes.string,
    xAxisCategorySortingType: PropTypes.string,
    xAxisCategoryOrdering: PropTypes.string,

    yAxisLabel: PropTypes.string,
    yAxisMin: PropTypes.number,
    yAxisMax: PropTypes.number,
    yAxisTickInterval: PropTypes.number,

    decimalPlaces: PropTypes.number,

    aggregateDataByCategory: PropTypes.bool,

    propertySeriesQueries: PropTypes.array,
    aggregateSeriesQueries: PropTypes.array,

    dynamicProperty: PropTypes.string,
};

export default ColumnChartBlock;
